export default "__VITE_ASSET__Bc2ArLC5__"